import type { Point } from './types';

export interface GroundProbe { isSolid(x: number, y: number): boolean }
export interface ShotPose extends Point { face: -1 | 1 }

/** Pinned later client PhysicalObj.calcObjectAngle, not a dated 2009 constant.
 * Sample offsets 1,3,...,15 on both sides, find the first empty pixel while
 * scanning y+10..y-10, average each side with the player anchor, then floor the
 * screen-space angle as MathUtils.GetAngleTwoPoint does. */
export function terrainBodyAngle(ground: GroundProbe, pose: Point, radius = 16): number {
  const averages: Point[] = [];
  for (const direction of [1, -1]) {
    let sumX = pose.x, sumY = pose.y, count = 1;
    for (let offset = 1; offset <= radius; offset += 2) {
      for (let vertical = -10; vertical <= 10; vertical++) {
        const x = pose.x + direction * offset, y = pose.y - vertical;
        if (!ground.isSolid(x, y)) {
          if (vertical !== -10) { sumX += x; sumY += y; count++; }
          break;
        }
      }
    }
    averages.push({ x: sumX / count, y: sumY / count });
  }
  return Math.floor(Math.atan2(averages[0].y - averages[1].y, averages[0].x - averages[1].x) * 180 / Math.PI);
}

/** GamePlayer._ballpos=(30,-20), body.scaleX=-1, movie.scaleX=-direction,
 * movie.y=-3. Translation is outside movie.rotation in Flash's transform. */
export function sourceBodyPoint(pose: ShotPose, bodyAngle: number, local: Point = { x: 30, y: -20 }): Point {
  const radians = bodyAngle * Math.PI / 180;
  const localX = pose.face * local.x;
  return { x: pose.x + localX * Math.cos(radians) - local.y * Math.sin(radians),
    y: pose.y - 3 + localX * Math.sin(radians) + local.y * Math.cos(radians) };
}

/** LocalPlayer.calcBombAngle is relative to the rotated player's ground plane;
 * GameInSocketOut.sendGameCMDShoot transports integer x/y/angle to the server. */
export function sourceShotGeometry(ground: GroundProbe, pose: ShotPose, gunAngle: number) {
  const bodyAngle = terrainBodyAngle(ground, pose);
  const muzzle = sourceBodyPoint(pose, bodyAngle);
  const worldAngle = Math.trunc(pose.face > 0 ? bodyAngle - gunAngle : bodyAngle + gunAngle - 180);
  return { bodyAngle, muzzle, origin: { x: Math.trunc(muzzle.x), y: Math.trunc(muzzle.y) }, worldAngle };
}
